import Vue from 'vue'
import Vuex from 'vuex'
import tdInitialState from './tdInitialState.js'
import tdApi from "./tdApi";
import tdGlobals from "./tdGlobals";

//translations
import { tdTranslations, tdTranslationsEventTypes, translate, translateEventTypes } from './tdVueTranslations.js';
Vue.prototype.$tdTranslations = tdTranslations;
Vue.prototype.$tdTranslationsEventTypes = tdTranslationsEventTypes;
Vue.prototype.$__ = translate;
Vue.prototype.$ev__ = translateEventTypes;

Vue.use(Vuex);

export const store = new Vuex.Store({

    // set the initial state
    state: tdInitialState.getNewInitialState(),

    mutations: {

        /**
         * usefull for development
         * @param state
         * @param newState
         */
        devReplaceState(state, newState) {
            Object.assign(state, newState)
        },




        /**
         * Logs in a user. WARNING: only works on login page and register user. And on other pages only when it's an admin.
         * Because users/get_user_by_id only returns all the data to the admin. It does not return the access token to non admins
         * @param apiUserObject
         */
        logInUser(state, apiUserObject) {
            state.user = apiUserObject;

        },

        /**
         * Update the company info, mostly used on settings
         * @param apiCompanyObject
         */
        updateCompany(state, apiCompanyObject) {
            state.company = apiCompanyObject;
            // also set the language to the company language
            state.companyLanguage = apiCompanyObject.language;
        },


        logInCompanyFromApi(state, apiReply) {
            state.user = apiReply.user;
            state.company = apiReply.company;

            // also set the language to the company language
            state.companyLanguage = apiReply.company.language;

            // used to hide and show the overtime reports based on the events if they are enabled or disabled
            state.uiDynamicSettings = apiReply.ui_dynamic_settings;

            // read the available features / premium from the api
            state.availableFeatures = apiReply.available_features;

            // load the user permissions
            state.permissions = apiReply.permissions;

            state.lockedMonths = apiReply.locked_months;

            state.subscriptionStatus = apiReply.subscription_status;

            EventBus.$emit('on_logInCompanyFromApi', {});
        },


        // used when an event type is enable or disabled - to hide reports based on the enabled event types
        updateUiDynamicSettings(state, apiUiDynamicSettingsObject) {
            state.uiDynamicSettings = apiUiDynamicSettingsObject;
        },

        //
        updatePermissions(state, apiPermissionsObject) {
            state.permissions = apiPermissionsObject;
        },

        //
        updateLockedMonths(state, apiPermissionsObject) {
            state.lockedMonths = apiPermissionsObject;
        },


        redirectAfterLoginToUrl(state, redirectToUrl) {
            state.redirectAfterLoginToUrl = redirectToUrl;
        },


        // subscriptionStatus(state, apiSubscriptionStatus) {
        //     state.subscriptionStatus = apiSubscriptionStatus;
        // },

        /**
         * we basically replace the whole state with the initial state
         * @param state
         */
        logOut(state) {
            Object.assign(state, tdInitialState.getNewInitialState());
        },

        logOutEfactura(state) {
            Object.assign(state, tdInitialState.getNewInitialState());
        },





        // event list
        eventsLoad(state, apiEventListObject) {
            state.eventList = apiEventListObject;
            //Object.assign(state.eventList, apiEventListObject);
        },



        // load the teams
        teamsLoad(state, apiTeamListObject) {
            state.teams = apiTeamListObject;
        },

        // load locations
        locationsLoad(state, apiListObject) {
            state.locations = apiListObject;
        },

        // load job titles
        jobTitlesLoad(state, apiListObject) {
            state.job_titles = apiListObject;
        },

		// load employment motivations
		employmentEndMotivationsLoad(state, apiListObject) {
			state.employmentEndMotivations = apiListObject;
		},


        //load projects
        projectsLoad(state, projects) {
            state.projects = projects;
        },

        //load projects
        projectsBranchLoad(state, branchProjects) {
            state.branchProjects = branchProjects;
        },


        // load the users
        usersLoad(state, apiUserListObject) {
            state.users = apiUserListObject;
        },

        // load the users used on event add/edit
        eventsUsersLoad(state, apiUserListObject) {
            state.eventsUsers = apiUserListObject;
        },

        // load teams users list
        teamsUsersLoad(state, apiUserListObject) {
            state.teamsUsers = apiUserListObject;
        },

        // load contract suspension reasons
        contractSuspensionReasonsLoad(state, apiListObject) {
            state.contractSuspensionReasons = apiListObject;
        },

        // load contract types
        contractTypesLoad(state, apiListObject) {
            state.contractTypes = apiListObject;
        },


		updateCurrentUserLanguage(state, apiLanguage) {
			Vue.set(state.user, 'language', apiLanguage);
		},



        // load user
        loadUser(state, apiUserObject) {
            let userIndex = state.users.findIndex(user => (parseInt(user.ID) === parseInt(apiUserObject.ID)));
            Vue.set(state.users, userIndex, apiUserObject);
        },

        // load into the state the available event types
        eventTypesLoad(state, apiEventTypesObject) {
            state.eventTypes = apiEventTypesObject;
        },

        // load into the state the available log changes
        logChangesLoad(state, apiLogChangesObject) {
            state.changesLog = apiLogChangesObject;
        },

		// load leave days types
		leaveDaysTypesLoad(state, apiEventTypesObject) {
			state.leaveDaysTypes = apiEventTypesObject;
		},


        /**
         * set the company language, used on pages where the user is NOT logged in (login, register etc)
         * @param state
         * @param newLanguage  (en_US is default, ro_RO etc)
         */
        setCompanyLanguage(state, newLanguage) {
            state.companyLanguage = newLanguage;
        },

        /**
         * Set modal state open/closed, used to add a class on main container to fix scroll on mobiles
         * @param state
         * @param newState
         */
        setModalIsOpen(state, newState) {
            state.modalIsOpen = newState;
        },


        /**
         * Set search bar state open/closed
         * @param state
         * @param newState
         */
        setSearchBarIsOpen(state, newState) {
            state.searchBarIsOpen = newState;
        },

        /**
         * Set unread notifications number
         * @param state
         * @param newState
         */
        setUnreadNotifications(state, newState) {
            state.unreadNotifications = newState;
        },

        /**
         * Set unread reminders number
         * @param state
         * @param newState
         */
        setUnreadReminders(state, newState) {
            state.unreadReminders = newState;
        },

        /**
         * Set unread reminders number
         * @param state
         * @param newState
         */
        setUnreadComments(state, newState) {
            state.unreadComments = newState;
        },



        /**
         * Set selected RFID device
         * - used on user/settings/rfid to remember last selected RFID device
         * @param state
         * @param newState
         */
        setSelectedRFIDDevice(state, newState) {
            state.selectedRFIDDevice = newState;
        },

        /**
         * Set search bar state open/closed
         * @param state
         * @param newState
         */
        setLoginRfid(state, newState) {
            state.loginRfidOn = newState;

            //Set CSS class for iframe in electron.
            if (newState === true) {
                jQuery('html').addClass('td-is-electron');
            }
        },

        /**
         * Set iphone or ipod state because of the policy of AppStore regarding external billing
         * @param state
         * @param newState
         */
        setIphoneOrIpodState(state, newState) {
            state.isIphoneOrIpod = newState;
        },

        /**
         * Set iphone or ipod state because of the policy of AppStore regarding external billing
         * @param state
         * @param newState
         */
        setIsMobileState(state, newState) {
            state.isMobile = newState;
        },

        /**
         * Set subscription status
         * @param state
         * @param newState
         */
        setSubscriptionStatus(state, subscriptionStatus) {
            state.subscriptionStatus = subscriptionStatus;
        },

        accountIsConnectedStateEfactura(state, newState) {
            state.accountIsConnected = newState;
        },

        accessStateToSpvCompaniesEfactura(state, newState) {
            state.accessFlagToSpvCompaniesEfactura = newState;
        }

    },
    getters: {

        /**
         * Checks if we're logged in
         * @param state
         * @returns {boolean}
         */
        isLoggedIn: function (state) {
            if (state.user === null) {
                return false;
            }
            return true;
        },


        /**
         * Checks if we're logged in with RFID For EVENTS
         * @param state
         * @returns {boolean}
         */
        isLoggedInWithRfid: function (state) {
            return state.loginRfidOn !== false;
        },

        /**
         * Checks if we're logged in with iphone or ipad
         * measure neccesary for app store because of their policy against billing outside their store.
         * @param state
         * @returns {boolean}
         */
        isIphoneOrIpodState: function (state) {
            return state.isIphoneOrIpod !== false;
        },

        /**
         * Checks if we're logged in with any of mobile smartphones
         *
         * @param state
         * @returns {boolean}
         */
        isMobile: function (state) {
            return state.isMobile !== false;
        },

        /**
         * Checks if the current user is admin
         * @param state
         * @returns {boolean}
         */
        isAdmin: function (state) {
            if (state.user !== null && state.user.user_type === 'admin') {
                return true;
            }
            return false;
        },

        /**
         * Linked companies number
         * @param state
         * @returns {int}
         */
        linkedCompanies: function (state) {
            if (state.user !== null && state.user.hasOwnProperty('linked_companies')) {
                return state.user.linked_companies;
            }
            return 1;
        },

        /**
         * Checks if the current user is super admin
         * @param state
         * @returns {boolean}
         */
        isSuperAdmin: function (state) {
            if (state.user !== null && state.user.is_super_admin === true) {
                return true;
            }
            return false;
        },

        /**
         * Check for super admin level
         * @param state
         * @returns {function(*=): boolean}
         */
        checkSuperAdminLevel: function(state) {
            return function(level = '') {
                let super_admin_level = state.user.super_admin_level !== null ? state.user.super_admin_level : '';

                return (super_admin_level === '' || super_admin_level === level);
            }
        },

        /**
         * Checks if the current user is team leader
         * @param state
         * @returns {boolean}
         */
        isTeamLeader: function (state) {
            if (state.user !== null && state.user.user_type === 'team_leader') {
                return true;
            }
            return false;
        },

        /**
         * Checks if the current user is team member
         * @param state
         * @returns {boolean}
         */
        isTeamMember: function (state) {
            if (state.user !== null && state.user.user_type === 'team_member') {
                return true;
            }
            return false;
        },

        isTeamLeaderHr(state) {
            if (state.user !== null && state.user.user_type === 'team_leader' && (state.user.team_leader_hr === true || state.user.team_leader_hr === '1')) {
                return true;
            }
            return false;
        },

        isTeamLeaderHrOnDepartments(state) {
            if (state.user !== null && state.user.user_type === 'team_leader' && (state.user.team_leader_hr === true || state.user.team_leader_hr === '1') && state.user.team_leader_hr_on_departments === true) {
                return true;
            }
            return false;
        },

        isTeamLederOrAdmin: function (state) {
            if (state.user !== null && (state.user.user_type === 'team_leader' || state.user.user_type === 'admin')) {
                return true;
            }
            return false;
        },

        isUnockTriggresWorkSchedule(state) {
            if (state.availableFeatures && state.availableFeatures.features_settings.triggers_on_work_schedule.unlock) {
                return true;
            }

            return false;
        },

        isUnlockCalculationTabs(state) {
            if (state.availableFeatures &&  state.availableFeatures.features_settings.calculation_tabs.unlock) {
                return true;
            }

            return false;
        },

        useLockedMonths(state) {
            if (state.company !== null && state.company.use_locked_months === '1') {
                return true;
            }

            return false;
        },

		useProjects(state) {
			if (state.company === null || state.company.use_projects === undefined) {
				return false;
			}

			return state.company.use_projects;
		},

        getUserTeamsIds: function (state) {
            if (state.user !== null) {
                return parseInt(state.user.teams_ids);
            }
            return false;
        },

        filePermissionTeamLeader(state) {
            if (state.company !== null && state.company.file_permission_team_leader !== undefined) {
                return state.company.file_permission_team_leader;
            }

            return false;
        },

		getUsersEditOwnAttendance(state) {
			if (state.company !== null && state.company.users_edit_own_attendance !== undefined) {
				return state.company.users_edit_own_attendance;
			}

			return false;
		},



        /**
         * Get current user ID
         * @param state
         * @returns {*}
         */
        getUserID: function (state) {
            if (state.user !== null) {
                return state.user.ID;
            }
            return false;
        },


        getSubscriptionStatus: function (state) {
            if (state.subscriptionStatus !== null) {
                return state.subscriptionStatus;
            }
            return false;
        },

        getUnlockCheckInOutDatetimeFor(state) {
			if (state.company === null || state.company.unlock_check_in_out_datetime_for === undefined) {
				return false;
			}

            //fix - remove disable option ''
            let unlock_check_in_out_datetime_for = 'admins';
            if (typeof state.company.unlock_check_in_out_datetime_for === 'string' && state.company.unlock_check_in_out_datetime_for.length > 0) {
                unlock_check_in_out_datetime_for = state.company.unlock_check_in_out_datetime_for;
            }

			return unlock_check_in_out_datetime_for;
		},

		getEventsCanEditAll: function(state) {
        	if (state.user === undefined || state.user.events_can_edit_all === null || state.user.events_can_edit_all === undefined) {
        		return false;
			}

        	return state.user.events_can_edit_all === '1';
		},
        getReviewsTemplatesPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_templates_permission === null || state.user.reviews_templates_permission === undefined) {
                return false;
            }

            return state.user.reviews_templates_permission === '1';
        },

        getReviewsSessionsPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_sessions_permission === null || state.user.reviews_sessions_permission === undefined) {
                return false;
            }

            return state.user.reviews_sessions_permission === '1';
        },

        getReviewsAccessPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_access_permission === null || state.user.reviews_access_permission === undefined) {
                return false;
            }

            return state.user.reviews_access_permission === '1';
        },

        getReviewsEditPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_edit_permission === null || state.user.reviews_edit_permission === undefined) {
                return false;
            }

            if (state.user.reviews_access_permission === null || state.user.reviews_access_permission === undefined) {
                return false;
            }

            if(state.user.reviews_access_permission !== '1'){
                return false;
            }

            return state.user.reviews_edit_permission === '1';
        },


        getReviewsViewPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_view_permission === null || state.user.reviews_view_permission === undefined) {
                return false;
            }

            if (state.user.reviews_access_permission === null || state.user.reviews_access_permission === undefined) {
                return false;
            }

            if(state.user.reviews_access_permission !== '1'){
                return false;
            }

            return state.user.reviews_view_permission === '1';
        },

        getReviewsViewReportPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_view_report_permission === null || state.user.reviews_view_report_permission === undefined) {
                return false;
            }
            return state.user.reviews_view_report_permission == '1';
        },

        getReviewsReportChangeStatusPermission: function(state) {
            if (state.user === undefined || state.user === null || state.user.reviews_report_change_status_permission === null || state.user.reviews_report_change_status_permission === undefined) {
                return false;
            }

            if (state.user.reviews_view_report_permission === null || state.user.reviews_view_report_permission === undefined) {
                return false;
            }

            if(state.user.reviews_view_report_permission !== '1'){
                return false;
            }

            return state.user.reviews_report_change_status_permission === '1';
        },

		getUsersAttendanceViewAll: function(state) {
			if (state.company === null || state.company.users_attendance_view_all === undefined) {
				return false;
			}

			return state.company.users_attendance_view_all;
		},


		/**
		 * Used for replacing 'Projects' with custom name
		 * @param state
		 * @returns {function(*=): (string|*)}
		 */
		getProjectsName: function(state) {
			if (state.company.projects_name !== '' && state.company.projects_name !== null) {
				return _.upperFirst(state.company.projects_name);
			}

			return '';
		},

        getProjectsNameNew: function(state) {
            return function(defaultText, altText) {
                let projectsName = '';

                if (state.company.projects_name !== '' && state.company.projects_name !== null) {
                    projectsName = _.upperFirst(state.company.projects_name);
                }

                //projects name is empty, return default text
                if (projectsName === '') {
                    return Vue.prototype.$__.call(Vue.prototype, defaultText);
                }

                //altText with projects name, ex. 'Filter $0' -> 'Filter Projects'
                if (altText !== undefined && altText !== null) {
                    return Vue.prototype.$__.call(Vue.prototype, altText, [projectsName]);
                }

                return projectsName;
            }
        },

		useCheckInOut: function(state) {
			if (!state.company || state.company.use_check_in_out !== '1') {
				return false;
			}

			return true;
		},


		locationCheckInPage: function(state) {
			if (!state.company || state.company.location_check_in_page !== '1') {
				return false;
			}

			return true;
		},


        photoCheckInOut: function(state) {
            return state.company.photo_check_in_out === '1';
		},


        checkInFromUserAccountDisabled: function(state) {
			if (state.user.disabled_check_in_from_user_account === '1') {
				return false;
			}

			return true;
		},



        hasPermission: function (state) {
            return function(permissionName, forResourceID, context = 'default') {
                let resurceIds = [];

                if (Array.isArray(context)) {
                    context.forEach(function(contextName){
						if (state.permissions[permissionName] &&
							state.permissions[permissionName][contextName] &&
							Array.isArray(state.permissions[permissionName][contextName]['resource_id']))
						{
							resurceIds = resurceIds.concat(state.permissions[permissionName][contextName].resource_id)
						}

                    });

                    //array_unique
                    resurceIds = resurceIds.filter(function(value, index, self) {
                        return self.indexOf(value) === index;
                    });

                } else if (state.permissions[permissionName] &&
					state.permissions[permissionName][context] &&
					Array.isArray(state.permissions[permissionName][context]['resource_id']))
				{
                    resurceIds = state.permissions[permissionName][context]['resource_id'];
                }

                let resourceIdFound = false;

                if (forResourceID !== undefined && forResourceID !== null && Array.isArray(forResourceID)) {
                    for (let i = 0; i < forResourceID.length; i++) {
                        let currentResourceId = forResourceID[i];

                        resurceIds.find(function(resourceID) {
                            if (parseInt(resourceID) === parseInt(currentResourceId)) {
                                resourceIdFound = true;
                            }
                        });

                        if (resourceIdFound === true) {
                            break;
                        }
                    }
                } else {
                    resurceIds.find(function(resourceID) {
                        if (parseInt(resourceID) === parseInt(forResourceID)) {
                            resourceIdFound = true;
                        }
                    });
                }

                return resourceIdFound;

            }
        },

        hasAnyPermission: function (state) {
            return function(permissionName, context = 'default') {
                if (state.permissions !== null) {
                    let resurceIds = [];

                    if (Array.isArray(context)) {
                        context.forEach(function(contextName){

							if (state.permissions[permissionName] &&
								state.permissions[permissionName][contextName] &&
								Array.isArray(state.permissions[permissionName][contextName]['resource_id']))
							{
								resurceIds = resurceIds.concat(state.permissions[permissionName][contextName].resource_id)
							}
                        });

                        //array_unique
                        resurceIds = resurceIds.filter(function(value, index, self) {
                            return self.indexOf(value) === index;
                        });

                    } else if (state.permissions[permissionName] &&
							   state.permissions[permissionName][context] &&
							   Array.isArray(state.permissions[permissionName][context]['resource_id']))
                    {
                        resurceIds = state.permissions[permissionName][context]['resource_id'];
                    }

                    return resurceIds.length > 0;
                }

                return false;
            }
        },

        // hasEnabledReports: function(state) {
        //     if (
        //         !state.company ||
        //         !state.user ||
        //         Array.isArray(state.company.disabled_reports) === false ||
        //         Array.isArray(state.company.disabled_reports_team_leaders_hr) === false ||
        //         Array.isArray(state.company.disabled_reports_team_leaders) === false ||
        //         Array.isArray(state.company.disabled_reports_team_members) === false)
        //     {
        //         return false;
        //     }
        //
        //     let buffy = false,
        //         reportsList = tdGlobals.reportsSlugs;
        //
        //     //admin
        //     if (state.user.user_type === 'admin') {
        //         if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.user.disabled_reports.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         } else {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.company.disabled_reports.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }
        //
        //     //team leader HR
        //     if (state.user.user_type === 'team_leader' && (state.user.team_leader_hr === true || state.user.team_leader_hr === '1')) {
        //         if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.user.disabled_reports.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         } else {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.company.disabled_reports_team_leaders_hr.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }
        //
        //     //team leader
        //     if (state.user.user_type === 'team_leader' && (state.user.team_leader_hr === false || state.user.team_leader_hr === '0')) {
        //         if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.user.disabled_reports.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         } else {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.company.disabled_reports_team_leaders.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }
        //
        //     //team member
        //     if (state.user.user_type === 'team_member') {
        //         if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.user.disabled_reports.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         } else {
        //             for (let i=0; i < reportsList.length; i++) {
        //                 let currentReportSlug = reportsList[i];
        //                 if (state.company.disabled_reports_team_members.indexOf(currentReportSlug) === -1) {
        //                     buffy = true;
        //                     break;
        //                 }
        //             }
        //         }
        //     }
        //
        //     return buffy;
        // },

        hasEnabledReports: function(state) {
            let buffy = false;

            for (let i = 0; i < tdGlobals.reportsSlugs.length; i++) {
                let reportSlug = tdGlobals.reportsSlugs[i];

                if (store.getters.reportIsDisabled(reportSlug) === false) {
                    buffy = true;
                    break;
                }
            }

            return buffy;
        },

		reportIsDisabled: function (state) {
			return function(reportSlug) {
				if (
                    !state.company ||
                    !state.user ||
                    Array.isArray(state.company.disabled_reports) === false ||
                    Array.isArray(state.company.disabled_reports_team_leaders_hr) === false ||
                    Array.isArray(state.company.disabled_reports_team_leaders) === false ||
                    Array.isArray(state.company.disabled_reports_team_members) === false)
                {
					return true;
				}

                if(reportSlug == 'reviews'){
                    return false;
                }

                //admin
                if (state.user.user_type === 'admin') {
                    if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
                        return state.user.disabled_reports.indexOf(reportSlug) !== -1;
                    } else {
                        return state.company.disabled_reports.indexOf(reportSlug) !== -1;
                    }
                }

                //team leader HR
                if (state.user.user_type === 'team_leader' && (state.user.team_leader_hr === true || state.user.team_leader_hr === '1')) {
                    if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
                        return state.user.disabled_reports.indexOf(reportSlug) !== -1;
                    } else {
                        return state.company.disabled_reports_team_leaders_hr.indexOf(reportSlug) !== -1;
                    }
                }

                //team leader
                if (state.user.user_type === 'team_leader' && (state.user.team_leader_hr === false || state.user.team_leader_hr === '0')) {
                    if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
                        return state.user.disabled_reports.indexOf(reportSlug) !== -1;
                    } else {
                        return state.company.disabled_reports_team_leaders.indexOf(reportSlug) !== -1;
                    }
                }

                //team member
                if (state.user.user_type === 'team_member') {
                    if (state.user.disabled_reports_is_enabled === true || state.user.disabled_reports_is_enabled === '1') {
                        return state.user.disabled_reports.indexOf(reportSlug) !== -1;
                    } else {
                        return state.company.disabled_reports_team_members.indexOf(reportSlug) === -1;
                    }
                }

                return true;
			}
		},


        // returns the store index of a user based on int's id (user has to be enabled)
        getUserIndexByID: function (state) {
            return function(userID) {
                return state.users.findIndex(user => (parseInt(user.ID) === parseInt(userID) && user.is_enabled === true) );
            }
        },

        // returns the store index of a user based on int's id
        // @todo this has to be marged with the function above :))
        getAnyUserIndexByID: function (state) {
            return function(userID) {
                return state.users.findIndex(user => (parseInt(user.ID) === parseInt(userID)));
            }
        },


        getAnyEventsUserIndexByID: function (state) {
            return function(userID) {
                return state.eventsUsers.findIndex(user => (parseInt(user.ID) === parseInt(userID)));
            }
        },


        //returns a user object from the store based on the user.id (NOT THE USER INDEX)
        getUserObjByID: function (state) {
            return function(userID) {
                return state.users.find(function(userObj){
                    if (parseInt(userObj.ID) === parseInt(userID)) {
                        return userObj;
                    }
                });
            }
        },



        getEventTypeByID: function (state) {
            return function(eventTypeID) {
                return state.eventTypes.find(eventType => parseInt(eventType.ID) === parseInt(eventTypeID));
            }
        },

        getTeamByID: function (state) {
            return function(teamID) {
                return state.teams.find(team => parseInt(team.ID) === parseInt(teamID));
            }
        },

        getTeamsByIDS: function (state) {
            return function(teamIDS) {
                if(teamIDS === undefined){
                    return state.teams;
                }
                return state.teams.filter(team => teamIDS.indexOf(team.ID) !== -1);
            }
        },

        getTeamsNamesByIDS: function (state) {
            return function(teamIDS, returnAsString) {
                let buffy = [];

                if (Array.isArray(teamIDS)) {
                    teamIDS = teamIDS.map(function (teamId){
                        return teamId + '';
                    });
                    let teams = state.teams.filter(team => teamIDS.indexOf(team.ID) !== -1);

                    teams.forEach(function(team) {
                        buffy.push(team.team_name);
                    });
                }

                //return teams names as string
                if (returnAsString === true) {
                    buffy = buffy.join(', ');
                }

                return buffy;
            }
        },

        getLocationByID: function (state) {
            return function(locationID) {
                return state.locations.find(location => parseInt(location.ID) === parseInt(locationID));
            }
        },

        getJobTitleByID: function (state) {
            return function(jobTitleID) {
                return state.job_titles.find(job_title => parseInt(job_title.ID) === parseInt(jobTitleID));
            }
        },

        getProjectByID: function (state) {
            return function(projectID) {
                return state.projects.find(project => parseInt(project.ID) === parseInt(projectID));
            }
        },

		getEmploymentEndMotivationByID: function (state) {
			return function(motivationID) {
				return state.employmentEndMotivations.find(motivation => parseInt(motivation.ID) === parseInt(motivationID));
			}
		},

        getContractSuspensionReasonByID: function (state) {
            return function(reasonID) {
                return state.contractSuspensionReasons.find(reason => parseInt(reason.ID) === parseInt(reasonID));
            }
        },

        getContractTypeByID: function (state) {
            return function(contractTypeID) {
                return state.contractTypes.find(contractType => parseInt(contractType.ID) === parseInt(contractTypeID));
            }
        },

        getDateFormat(state) {
            return function() {
                let companyDateFormat = state.company.date_format,
                    dateFormat = null;

                switch(companyDateFormat) {
                    case 'mdy':
                        dateFormat = 'mm/dd/yy';
                        break;
                    case 'dmy':
                        dateFormat = 'dd/mm/yy';
                        break;
                    case 'ymd':
                        dateFormat = 'yy/mm/dd';
                        break;
                }

                return dateFormat;
            }
        },

        getMomentDateFormat(state) {
            return function() {
                let companyDateFormat = state.company.date_format,
                    dateFormat = null;

                switch(companyDateFormat) {
                    case 'mdy':
                        dateFormat = 'MM/DD/YYYY';
                        break;
                    case 'dmy':
                        dateFormat = 'DD/MM/YYYY';
                        break;
                    case 'ymd':
                        dateFormat = 'YYYY/MM/DD';
                        break;
                }

                return dateFormat;
            }
        },


        // date type use to validate date picker calendar;
        getMomentDateFormatSingleType(state) {
            return function() {
                let companyDateFormat = state.company.date_format,
                    dateFormat = null;

                switch(companyDateFormat) {
                    case 'mdy':
                        dateFormat = 'M/D/YYYY';
                        break;
                    case 'dmy':
                        dateFormat = 'D/M/YYYY';
                        break;
                    case 'ymd':
                        dateFormat = 'YYYY/M/D';
                        break;
                }

                return dateFormat;
            }
        },


        getCompanyRegDate(state) {
            return function() {
                let regexp = /\d{4}-\d{2}-\d{2}/g, //match YYYY-MM-DD date
                    companyRegDate = state.company.created.match(regexp),
                    date = null;

                if (companyRegDate !== null) {
                    let splitDate = companyRegDate[0].split('-');
                    date = new Date(splitDate[0], splitDate[1] - 1, 1)
                }

                return date;
            }
        },


        /**
         * gets the current logged in company language
         * @param state
         * @returns {*}
         */
        getCompanyLanguage(state) {
            return state.companyLanguage;
        },



        getCompanyObj(state) {
            return state.company;

        },

		/**
		 * Get current logged in user language
		 * @param state
		 * @returns {string|default.methods.language|default.methods.language|default.methods.language|*}
		 */
		getUserLanguage(state) {
        	if (state.user && state.user.language && state.user.language !== '') {
        		return state.user.language;
			}

			return state.companyLanguage;
		},

        /**
         * get's the deploy type. The deploy type is set by webpack and it's injected in the index.html file
         * @param state
         * @returns {string}
         */
        getTdDeployType(state) {
            return window.tdDeployInject.deployType;
        },

        getSearchBarIsOpen(state) {
            return state.searchBarIsOpen;
        },

        getUnreadNotifications(state) {
            return state.unreadNotifications;
        },

        getUnreadReminders(state) {
            return state.unreadReminders;
        },

        getUnreadComments(state) {
            return state.unreadComments;
        },

        getUiDynamicSettings(state) {
          return state.uiDynamicSettings;
        },


        /**
         * get premium features
         * @param state
         * @returns {{partial_approve: {is_enabled: boolean}}}
         */
        getAvailableFeatures(state) {
            return state.availableFeatures;

        },

        /**
         * check if an event types is disabled
         * - only business event types can be disabled, the rest are enabled by default
         * @param state
         * @returns {(function(*): (boolean|*))|*}
         */
        businessEventTypeIsDisabled(state) {
            return function(eventTypeSlug) {
                if(eventTypeSlug === undefined || !state.company || !state.company.business_event_types_enabled){
                    return false;
                }

                let businessEventTypes = state.company.business_event_types !== undefined ? state.company.business_event_types : [];

                return businessEventTypes.includes(eventTypeSlug) && !state.company.business_event_types_enabled.includes(eventTypeSlug);
            }
        },

        accountIsConnectedEfactura(state) {
            return state.accountIsConnected;
        },

        accessToSpvCompaniesEfactura(state) {
            return state.accessFlagToSpvCompaniesEfactura;
        }


    },

    actions: {
        //action defined in order to maintain the state of the user connected in efactura app. (it works especially when surfing from other route)
        isConnectedToAnafEfactura({ commit }, payload) {
            if (payload === true) {
                let apiCall = new tdApi('efactura/efactura/is_conented_to_anaf');
                apiCall.run({
                    'post': {},
                    'done': function (apiReply) {
                        commit('accountIsConnectedStateEfactura', apiReply.account_is_connected);
                    },
                    'error': function (error) {
                        console.error('Error fetching connection status: ', error);
                    }
                });
            }

        }
    },


});



// WEBPACK FOOTER //
// ./src/store.js